var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgStrawberryMenu = function SvgStrawberryMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 19.7H9.3c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h5.5c.6 0 1.1.5 1.1 1.1-.1.6-.5 1.1-1.2 1.1zM18.298 13.1h-12.6c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h12.5c.6 0 1.1.5 1.1 1.1 0 .6-.4 1.1-1 1.1zM21.498 6.5h-19c-.7 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h19.1c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.2 1.1z",
    fill: "#5B6C76"
  })));
};
export default SvgStrawberryMenu;